<app-main-layout
  [clickNext]="onClickNext"
  [clickBack]="onClickBack"
  [activateNextButton$]="nextButtonState.activateNext$"
  >
  @if (!ownershipRequiresVerification) {
    <div class="main-heading">
      <h2>What address will the project be at?</h2>
    </div>
  }
  @if (ownershipRequiresVerification) {
    <div class="main-heading">
      <h2>Which home would you like a quote for?</h2>
      <div
        [innerHtml]="'We want to make sure we provide services in your area.'"
        class="cs-inner-html-16"
      ></div>
    </div>
  }

  <form class="contact-form" [formGroup]="addressForm">
    <app-form-group
      label="Street Address 1"
      [required]="true"
      [id]="'streetAddress1'"
      formControlName="streetAddress1"
    ></app-form-group>
    <app-form-group
      label="Street Address 2"
      id="streetAddress2"
      formControlName="streetAddress2"
    ></app-form-group>
    <div class="inputs-row">
      <app-form-group
        label="City"
        [required]="true"
        id="city"
        formControlName="city"
      ></app-form-group>
      <div
        class="select-wrapper"
        [ngClass]="{
          error:
            addressForm.controls['state'].touched &&
            !addressForm.controls['state'].valid
        }"
        >
        <label class="state-label" for="state">State <span>*</span></label>
        <div class="icon-wrapper">
          @if (
            addressForm.controls['state'].value.trim() === '' &&
            !addressForm.controls['state'].touched
            ) {
            <img
              src="/assets/icons/cross-circle.svg"
              alt="No Value"
              class="empty"
              />
          }
          @if (
            addressForm.controls['state'].touched &&
            !addressForm.controls['state'].valid
            ) {
            <img
              src="/assets/icons/alert-circle.svg"
              alt="Invalid Value"
              class="invalid"
              />
          }
          @if (
            addressForm.controls['state'].value.trim() !== '' &&
            addressForm.controls['state'].valid
            ) {
            <img
              src="/assets/icons/check-circle.svg"
              alt="Valid Value"
              class="valid"
              />
          }
        </div>
        <ng-select
          #stateSelect
          appearance="outline"
          labelForId="state"
          formControlName="state"
          [clearable]="false"
          class="state-select"
          bindLabel="name"
          bindValue="id"
          [dropdownPosition]="'top'"
          >
          @for (option of statesList; track option) {
            <ng-option [value]="option.short">{{
              option.short
            }}</ng-option>
          }
        </ng-select>
        <div class="error-msg">
          @if (
            addressForm.controls['state'].invalid &&
            addressForm.controls['state'].touched
            ) {
            <div
              >
              @if (addressForm.controls['state'].errors?.['required']) {
                <span>{{
                  ERROR_MESSAGES.FIELD_REQUIRED
                }}</span>
              }
            </div>
          }
        </div>
      </div>
      <app-form-group
        label="Zipcode"
        [required]="true"
        id="zipcode"
        formControlName="zipcode"
        type="zip"
      ></app-form-group>
    </div>
    @if (addressForm.controls['state'].value === 'FL') {
      <div class="florida-approval">
        <span id="safe-florida-approval-question">
          Seeking My Safe Florida Home Approval?
        </span>
        <label class="approval-switch">
          <input
            type="checkbox"
            role="switch"
            formControlName="seekingSafeFloridaHomeApproval"
            aria-labelledby="safe-florida-approval-question"
          />
          <span class="switch-track" aria-hidden="true"></span>
          <span class="switch-value">
            {{ addressForm.controls['seekingSafeFloridaHomeApproval'].value ? 'Yes' : 'No' }}
          </span>
        </label>
        <a
          class="florida-approval-info"
          href="https://mysafeflhome.com"
          target="_blank"
          rel="noopener noreferrer"
        >What's this?</a>
      </div>
    }
    @if (ownershipRequiresVerification) {
      <div class="verification-block">
        <h2>Verify homeownership:</h2>
        <div
          [innerHtml]="'Registered Homeowners:'"
          class="cs-inner-html-16"
        ></div>
        @if (propertyOwners?.length) {
          <ol>
            @for (owner of propertyOwners; track owner) {
              <li>{{owner.firstName}} {{owner.lastName}}</li>
            }
          </ol>
        } @else {
          <span class="non-found">None Found</span>
        }
        <app-radio [radioGroup]="ownershipOptionsRadioGroup" [rounded]="true"></app-radio>
      </div>
    }
  </form>
</app-main-layout>
